export default function Header() {
    return <header className="up-header">
        <div className="wallet-logo">
            <div className="img-wrap">
                <img src="/img/logo-light.png" alt="" />
            </div>
        </div>
    </header>
}